import { render, staticRenderFns } from "./_template-language-selector.vue?vue&type=template&id=2d2a4322&scoped=true&"
import script from "./_template-language-selector.vue?vue&type=script&lang=js&"
export * from "./_template-language-selector.vue?vue&type=script&lang=js&"
import style0 from "./_template-language-selector.vue?vue&type=style&index=0&id=2d2a4322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a4322",
  null
  
)

export default component.exports